// CacheKey af937b129f25732d223a40d5976d641f
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-ASCENT": {
    models: {
      encounter: "visit",
      encounters: "visits",
      Encounter: "Visit",
      Encounters: "Visits"
    },
    exports: {
      defaults: {
        encounter: {
          id: "Visit ID",
          status: "Visit Status"
        }
      }
    },
    ribbon: {
      encounters: "Visits"
    }
  }
}

